import type { IUserProjectAssignment, IUserProjectSettings } from "../services/types/users";
import type { IYouTrackProjectOption } from "../services/youtrackProjects.service";
import { formatYouTrackProjectLabel } from "./youtrackProject";

export function buildProjectAssignments(
  selectedIds: string[],
  catalog: IYouTrackProjectOption[],
  savedProjectNames: Record<string, string>,
): IUserProjectAssignment[] {
  return selectedIds.map((projectId) => ({
    youTrackProjectId: projectId,
    projectName: resolveProjectName(projectId, catalog, savedProjectNames),
  }));
}

export function buildUserProjectSettingsPayload(
  worksInSelected: string[],
  managesSelected: string[],
  hasIncompleteWorkHours: boolean,
  catalog: IYouTrackProjectOption[],
  savedProjectNames: Record<string, string>,
): IUserProjectSettings {
  return {
    hasIncompleteWorkHours,
    worksInProjects: buildProjectAssignments(
      worksInSelected,
      catalog,
      savedProjectNames,
    ),
    managesProjects: buildProjectAssignments(
      managesSelected,
      catalog,
      savedProjectNames,
    ),
  };
}

function resolveProjectName(
  projectId: string,
  catalog: IYouTrackProjectOption[],
  savedProjectNames: Record<string, string>,
): string {
  const catalogProject = catalog.find((project) => project.id === projectId);
  if (catalogProject) {
    return formatYouTrackProjectLabel(
      catalogProject.shortName,
      catalogProject.name,
    );
  }

  const savedName = savedProjectNames[projectId]?.trim();
  if (savedName) {
    return savedName;
  }

  return projectId;
}
